import React from 'react'
import resultVideo from '../../assets/videos/result.mp4'
export default function ResultSection() {
  return (
    <>
  <div className="container px-3 md:px-10 m-auto " id='result'>
    <div className="w-full h-[500px] relative ">
    <video className='w-full h-full object-fill absolute top-0 left-0 right-0 bottom-0' autoPlay loop muted>
    <source src={resultVideo} className='w-full' type='video/mp4' />
</video>

    </div>
    <div className="w-11/12 md:w-1/2 m-auto relative  bottom-[180px] z-50  text-center shadow-md">
  <h1 className="h1 ">Result</h1>
  <div className="bg-white py-10 px-10 rounded-md space-y-16">
    <p className="p">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu mi bibendum neque egestas congue. Ullamcorper malesuada proin libero nunc consequat interdum varius. Ullamcorper malesuada proin libero nunc consequat interdum varius. 
    </p>
    <h1 className="h1 text-[#606C5D]">Result</h1>
  </div>

</div>
  </div>
    </>
  )
}
